
<f-dialog
    :title       = "$t('img.folder.create.title')"
    v-model      = "show"
    :width       = "460"
    :store-label = "$t('img.folder.create.store')"
    :show-save   = "valid && !running"
    @cancel      = "onCancel"
    @store       = "onSave"
>
    <template v-slot:content>
        <v-row dense>
            <v-col>
                <v-text-field
                    :label       = "$t('img.folder.create.name')"
                    v-model      = "name"
                    counter      = "100"
                    maxlength    = "100"
                    autocomplete = "off"
                    autofocus
                    @keyup.enter = "onSave"
                />
            </v-col>
        </v-row>
    </template>
</f-dialog>
